import './form-control-help.scss';
var AptoFormControlHelp = /** @class */ /*@__PURE__*/ (function () {
    function AptoFormControlHelp() {
        this.error = false;
    }
    return AptoFormControlHelp;
}());
export { AptoFormControlHelp };
